<template>
	<page enable-flex :create-button="auth('b_app_order_offline_create') && saasInfo.is_offline_order > 0" @create="checkDepositBefore(() => mp.navigateWeb('/sales/order/offline/create'))">
		<view-list ref="view" work-type="13" :search="{scan: true}">
			<template #filter>
				<m-search>
					<m-search-item label="订单号">
						<c-input name="keyword"></c-input>
					</m-search-item>
					<m-search-item label="客户">
						<c-select name="customer_id" async @search="searchCustomer"></c-select>
					</m-search-item>
					<m-search-item label="售卖类型">
						<c-select name="sell_type" :options="sellTypeOptions"></c-select>
					</m-search-item>
					<m-search-item label="创建时间">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template>

			<template #head="{data}">
				<div class="total-bar">
					<span>商品数量：{{fieldValid(data.product_count)}}</span>
					<span>销售金额：￥{{fieldValid(data.sale_amount)}}</span>
				</div>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #number>
						{{data.order_no}}
					</template>

					<template #state>
						<c-state dict="SALES_ORDER_STATE" :value="data.display_state == null ? data.order_state : data.display_state" type="state"></c-state>
					</template>

					<template #areaTag>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #areaName>
						{{[data.brand_name, data.model_name, data.memory_name, data.color_name].filter(item => item).join(' ') || '-'}}
					</template>

					<template #area>
						<c-field label="背贴码">{{data.produce_code}}</c-field>
						<c-field label="IMEI">{{data.imei}}</c-field>
						<c-field label="客户名称">{{data.customer_name}}</c-field>
						<c-field label="售卖类型">
							<c-state dict="SALE_SELL_TYPE" :value="data.sell_type"></c-state>
							<template v-if="data.sell_type == 2 && data.dismantle_items">
								<span>（</span>
								<template v-for="(item, i) in JSON.parse(data.dismantle_items)">
									<span v-if="i">、</span>
									<c-state :key="i" dict="DISMANTLE_ITEM" :value="item" color="#666"></c-state>
								</template>
								<span>）</span>
							</template>
						</c-field>
						<c-field label="售出价"><span style="color: #FF6900;">￥{{data.sale_price}}</span></c-field>
					</template>

					<template #operate>
						<c-button v-if="data.order_state == 1 && auth('b_app_order_offline_collect')" color="main" hollow @click="payHandle(data)">收款</c-button>
						<c-button v-if="auth('b_app_offline_order_cancel') && data.order_state == 1" icon="tf-cancel" @click="cancelOrder(data)">取消订单</c-button>
						<c-button v-if="auth('b_app_order_offline_view')" hollow @click="globalDialog('salesOrderDetail', {props: {orderType: 1, orderId: data.order_id}})">详情</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	import saasDeposit from '@/mixins/saas_deposit';
	import {mapState} from 'vuex'

	export default {
		mixins: [saasDeposit],
		computed: {
			...mapState(['saasInfo'])
		},
		data() {
			return {
				sellTypeOptions: [{
					name: '整机',
					value: 1
				}, {
					name: '拆机',
					value: 2
				}]
			}
		},
		
		methods: {
			searchCustomer(keyword, resolve) {
				this.request({
					url: '/sale/customer/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.customer_name,
								value: item.id
							};
						}));
					}
				});
			},
			
			payHandle(data) {
				this.globalDialog('offlineOrderPay', {
					props: {
						orderId: data.order_id
					}
				}, () => {
					this.$message({
						message: '操作成功'
					});
					this.$refs.view.update();
				})
			},

			cancelOrder(data) {
				this.$confirm({
					message: '确认取消该订单吗？取消后商品将恢复为可售状态',
					resolve: () => {
						this.request({
							url: '/offline/sale/order/cancel',
							data: {
								order_id: data.order_id,
								cancel_reason: '手动取消'
							},
							loading: true,
							success: () => {
								this.$message({
									message: '操作成功'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>